const LoadingSpinner = () => (
    <div className="spinner-container">
      <div className="spinner"></div>
      <p>Creating your product...</p>
    </div>
  );
  
  export default LoadingSpinner;
  